import { useQuery } from "@tanstack/react-query";
import { fetchAllStudioEnrollments } from "@/features/enrollments/shared/fetchAllStudioEnrollments";
import { useAccessToken } from "@/hooks/shared";
import { QueryKeys } from "@/lib/types";

export const studioEnrollmentsQueryKey = [
  QueryKeys.ClassesEnrollmentsByStudentId,
  "studio",
] as const;

interface UseStudioEnrollmentsGetOptions {
  enabled?: boolean;
  refetchOnMount?: boolean | "always";
  staleTime?: number;
}

export function useStudioEnrollmentsGet({
  enabled = true,
  refetchOnMount = false,
  staleTime = 5 * 60 * 1000,
}: UseStudioEnrollmentsGetOptions = {}) {
  const accessToken = useAccessToken();

  return useQuery({
    queryKey: studioEnrollmentsQueryKey,
    queryFn: async () => {
      const items = await fetchAllStudioEnrollments({
        accessToken: accessToken!,
      });
      return { items };
    },
    enabled: enabled && !!accessToken,
    refetchOnMount,
    refetchOnWindowFocus: false,
    staleTime,
    gcTime: 10 * 60 * 1000,
  });
}
